// src/pages/Supervisor/RegistrarSupervisorPage.jsx
import React from 'react';
import SupervisorForm from '../../components/Supervisor/SupervisorForm';

const RegistrarSupervisorPage = () => {
    return (
        <div>
            <h1>Registrar Supervisor</h1>
            <SupervisorForm onSuccess={() => alert('Supervisor registrado com sucesso!')} />
        </div>
    );
};

export default RegistrarSupervisorPage;